import React, { Component } from "react";
import Grid from "@material-ui/core/Grid";
import { withStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import { Box, Modal, Typography, Divider } from '@mui/material';
import { Link } from "react-router-dom";
import OrderButton from "./OrderButton";

import classicMacPic from "../images/menu/classic.jpeg";
import pulledPorkMacPic from "../images/menu/pulled-pork.jpeg";
import bbqChickenMacPic from "../images/menu/bbq-chicken.jpeg";
import blueBuffaloChickenMacPic from "../images/menu/blue-buffalo-chicken.jpeg";
import campMacPic from "../images/menu/camp.jpeg";
import carbonaraMacPic from "../images/menu/carbonara.jpeg";
import greenTreesMacPic from "../images/menu/green-trees.jpeg";
import spicyBoiMacPic from "../images/menu/spicy-boi.jpeg";
import vaganMacPic from "../images/menu/vegan.jpeg";

const styles = {
  foodMenu: {
    backgroundColor: '#0F0F0F',
    color: '#fff',
    overflow: "hidden"
  },
  grid: {
    width: 1200,
    marginTop: "4em",
    marginRight: 20,
    marginLeft: 20,
    backgroundColor: '#0F0F0F'
  },
  bold: {
    fontWeight: 600
  },
  paper: {
    padding: "3rem 12%",
    fontSize: 21,
  },
  headline: {
    marginBottom: "3rem"
  },
  h1: {
    fontWeight: 800,
  },
  h2: {
    fontSize: "4.5rem",
    fontWeight: 600,
    marginBottom: "3rem"
  },
  h3: {
    fontSize: "3rem",
    fontWeight: 600,
    marginBottom: "3rem"
  },
  h4: {
    fontSize: "1.5rem",
    marginBottom: "2rem"
  },
  firstIntro: {
    position: "relative",
    width: "100%"
  },
  firstPic: {
    float: "left",
    maxWidth: "100%",
    height: "auto"
  },
  secondIntro: {
    marginTop: "8rem",
    marginBottom: "8rem"
  },
  actionButton: {
    marginTop: "3rem"
  },
  menuImage: {
    width: "100%"
  },
  intro: {
    maxWidth: 640,
    margin: "0 auto",
    fontSize: "1.1rem",
    color: "rgba(255, 255, 255, 0.85)"
  },
  orderCta: {
    textAlign: "center",
    padding: "3rem 1rem 5rem !important"
  },
  orderCtaHeadline: {
    fontFamily: "Pacifico",
    fontSize: "2.5rem",
    lineHeight: 1.3,
    marginBottom: "1.75rem"
  },
  orderCtaNote: {
    fontSize: "0.95rem",
    color: "rgba(255, 255, 255, 0.75)",
    marginTop: "1.5rem",
    marginBottom: 0
  }
};

const modalStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};

class TheMenu extends Component {
  render() {
    const { classes } = this.props;

    return (
      <div id="food-menu" className={classes.foodMenu}>
        <Grid container justifyContent="center">
          <Grid
            className={classes.grid}
            alignItems="center"
            justifyContent="center"
            container
            spacing={5}
          >
            <Grid item xs={12} md={10} className={classes.headline}>
              <h2 className={`h1 ${classes.h1}`}>The Menu</h2>
              <p className={classes.intro}>
                Gooey, cheesy Toronto comfort food, from our five-cheese Classic Mac to pulled pork, BBQ chicken and vegan mac and cheese. Every mac comes in a small or a large, for takeout from our window or delivery.
              </p>
            </Grid>
            <Grid item xs={12} md={6}>
              <Grid container>
                <Grid item xs={12} md={8}>
                  <div>
                    <h3 className="h2">Classic Mac</h3>
                    <p>Our signature mac and cheese: cavatappi pasta in house-made béchamel sauce with a five-cheese blend of mozzarella, provolone, gouda and parmesan, topped with aged cheddar.</p>
                    <p><span>SM:</span> <span>11.45</span> <span>LG:</span> <span>17.25</span></p>
                  </div>
                </Grid>
                <Grid item xs={12} md={4}>
                <img src={classicMacPic} alt="Classic Mac served in a cast-iron skillet" className={classes.menuImage} />
                </Grid>
              </Grid>
              <Divider light={true} variant="fullWidth" style={{ borderColor: "rgba(255, 255, 255, 0.2)", marginTop: "2em" }}/>
            </Grid>
            <Grid item xs={12} md={6}>
              <Grid container>
                <Grid item xs={12} md={8}>
                  <div>
                  <h3 className="h2">Pulled Pork Mac</h3>
                  <p>Our Classic Mac topped with house-smoked pulled pork and BBQ sauce.</p>
                  <p><span>SM:</span> <span>15.95</span> <span>LG:</span> <span>21.75</span> <br /><br /></p>
                </div>
                </Grid>
                <Grid item xs={12} md={4}>
                <img src={pulledPorkMacPic} alt="Pulled Pork Mac served in a cast-iron skillet" className={classes.menuImage} />
                </Grid>
              </Grid>
              <Divider light={true} variant="fullWidth" style={{ borderColor: "rgba(255, 255, 255, 0.2)", marginTop: "2em" }}/>
            </Grid>

            <Grid item xs={12} md={6}>
              <Grid container>
                <Grid item xs={12} md={8}>
                  <div>
                    <h3 className="h2">BBQ Chicken Mac</h3>
                    <p>Our Classic Mac topped with pulled chicken and BBQ sauce.</p>
                    <p><span>SM:</span> <span>15.55</span> <span>LG:</span> <span>21.25</span> <br /></p>
                  </div>
                </Grid>
                <Grid item xs={12} md={4}>
                <img src={bbqChickenMacPic} alt="BBQ Chicken Mac served in a cast-iron skillet" className={classes.menuImage} />
                </Grid>
              </Grid>
              <Divider light={true} variant="fullWidth" style={{ borderColor: "rgba(255, 255, 255, 0.2)", marginTop: "2em" }}/>
            </Grid>
            <Grid item xs={12} md={6}>
              <Grid container>
                <Grid item xs={12} md={8}>
                <h3>Blue Buffalo Chicken Mac</h3>
                <p>Mac with béchamel sauce, blue cheese, chicken, buffalo sauce and topped with cheddar.</p>
                <p><span>SM:</span> <span>17.25</span> <span>LG:</span> <span>21.75</span></p>
                </Grid>
                <Grid item xs={12} md={4}>
                <img src={blueBuffaloChickenMacPic} alt="Blue Buffalo Chicken Mac served in a cast-iron skillet" className={classes.menuImage} />
                </Grid>
              </Grid>
              <Divider light={true} variant="fullWidth" style={{ borderColor: "rgba(255, 255, 255, 0.2)", marginTop: "2em" }}/>
            </Grid>
            <Grid item xs={12} md={6}>
              <Grid container>
                <Grid item xs={12} md={8}>
                <h3 className="h2">Camp Mac</h3>
                <p>Classic mac with beef hot dog medallions and yellow mustard.</p>
                <p><span>SM:</span> <span>13.75</span> <span>LG:</span> <span>19.45</span></p>
                </Grid>
                <Grid item xs={12} md={4}>
                <img src={campMacPic} alt="Camp Mac served in a cast-iron skillet" className={classes.menuImage} />
                </Grid>
              </Grid>
              <Divider light={true} variant="fullWidth" style={{ borderColor: "rgba(255, 255, 255, 0.2)", marginTop: "2em" }}/>
            </Grid>
            <Grid item xs={12} md={6}>
              <Grid container>
                <Grid item xs={12} md={8}>
                <h3 className="h2">Carbonara Mac</h3>
                <p>Classic carbonara with grana padano, pancetta and egg yolk.</p>
                <p><span>SM:</span> <span>16.25</span> <span>LG:</span> <span>22.25</span></p>
                </Grid>
                <Grid item xs={12} md={4}>
                <img src={carbonaraMacPic} alt="Carbonara Mac served in a cast-iron skillet" className={classes.menuImage} />
                </Grid>
              </Grid>
              <Divider light={true} variant="fullWidth" style={{ borderColor: "rgba(255, 255, 255, 0.2)", marginTop: "2em" }}/>
            </Grid>
            <Grid item xs={12} md={6}>
              <Grid container>
                <Grid item xs={12} md={8}>
                <h3 className="h2">Green Trees Mac</h3>
                <p>Our classic mac with broccoli and chili flakes.</p>
                <p><span>SM:</span> <span>13.75</span> <span>LG:</span> <span>19.45</span> <br /><br /><br /><br /><br /><br /></p>
                </Grid>
                <Grid item xs={12} md={4}>
                <img src={greenTreesMacPic} alt="Green Trees Mac served in a cast-iron skillet" className={classes.menuImage} />
                </Grid>
              </Grid>
              <Divider light={true} variant="fullWidth" style={{ borderColor: "rgba(255, 255, 255, 0.2)", marginTop: "2em" }}/>
            </Grid>
            <Grid item xs={12} md={6}>
              <Grid container>
                <Grid item xs={12} md={8}>
                <h3 className="h2">Vegan Mac</h3>
                <p>Our vegan mac and cheese: creamy and cheesy with a hint of smoke. Dairy-free and nut-free.</p>
                <p><span>SM:</span> <span>13.75</span> <span>LG:</span> <span>19.45</span></p>
                </Grid>
                <Grid item xs={12} md={4}>
                <img src={vaganMacPic} alt="Vegan Mac served in a cast-iron skillet" className={classes.menuImage} />
                </Grid>
              </Grid>
              <Divider light={true} variant="fullWidth" style={{ borderColor: "rgba(255, 255, 255, 0.2)", marginTop: "2em" }}/>
            </Grid>
            <Grid item xs={12} className={classes.orderCta}>
              <p className={classes.orderCtaHeadline}>Ready to dig in?</p>
              <OrderButton />
              <p className={classes.orderCtaNote}>
                Delivery and pickup through Uber Eats, DoorDash and SkipTheDishes, or just walk up to our window on Foxley Street.
              </p>
            </Grid>
          </Grid>
        </Grid>
      </div>
    );
  };
  }

export default withStyles(styles)(TheMenu);
